import styles from './Li.module.css';

const Li: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => <li className={styles.wrapper}>{children}</li>;

export default Li;
